const home = {
  namespaced: true,
  state: {
    sessionData: {
      session_lastLogonTime: ''
    },
    /*
    businessCode: null
    businessCodeTable: null
    customerMessage: null
    ec: "0"
    em: ""
    iAccountInfo: [{accountNo: "600000346150", accountType: "MSBC", accountName: "FSAGSASDA", currencyType: "USD",…},…]
    iBankNotice: []
    iLogQueryResult: []
    iOfenMenuList: []
    iOrderList: []
    loginFlag: null
    mainPage: null
    pageFlag: null
    pageStep: null
    sequenceNo: "1000001479531"
    session_businessTable: "{13000102=0, 10200000=0, 13000101=0, 10900203=0, 13000104=0, 00100400=0, 10200001=0, 10101400=0, 10800000=0, 20210803=0, 10101234=0, 10101500=0, 10100100=0, 10700400=0, 10200500=0, 10000400=0, 10200400=0, 10200300=0, 20210705=0, 20210707=0, 20210706=0, 20210630=0, 10101300=0, 12000110=0, 10700900=0, 10201100=0, 10700100=0, 10700700=0, 12000140=0, 10102500=0, 10100000=0, 20210429=0, 10700300=0, 10100101=0, 10700500=0, 10700200=0, 11100000=0, 10700600=0, 20210427=0, 20210428=0, 10700000=0}"
    session_certNo: ""
    session_certType: ""
    session_customerId: "CB10000476"
    session_hostNo: "90000116"
    session_lastLogonTime: "20211228164532"
    session_userId: "000001"
    session_userRight: "10000"
    userRightType: '0'    取session_userRight的第三位到第四位的值。(0：普通用户;1：表示管理员)  substring(3, 4)
    systemTime: "20211228"
    totalNumber: "0"
    tranCode: null
    userName: "张金阳"
    windowId: "null"
    */
    sessionInfo: {},
    // 城市列表
    countryList: []
  },
  mutations: {
    SET_SESSION_DATA (state, data) {
      state.sessionData = Object.assign({}, state.sessionData, data)
    },
    SET_SESSION_INFO (state, info) {
      state.sessionInfo = Object.assign({}, state.sessionInfo, info)
    },
    SET_COUNTRY_LIST (state, list) {
      state.countryList = list
    }
  },
  actions: {
  }
}

export default home
